import axios from "axios";
import { useCallback, useEffect, useRef, useState } from "react"; 
import { getCurrentIssueNumber, getNextIssueNumber } from "../utils/util";
import { TabProps } from "../components/LotteryTab";
// import { TabProps } from "@chatui/core";
import sleep from 'sleep-promise'
import _ from 'lodash'
import moment from "moment"; 
import { base } from "./usePlanners";

const useDrawResult = (tab?:TabProps)=>{
    console.log('useDrawResult',tab)
    const [drawResult,setDrawResult] = useState();
    const [loadingStatus,setLoadingStatus] = useState(true);
    const tabRef = useRef<TabProps>(tab)
    const loadCallback = useCallback(async ()=>{
        try{
            console.log('useDrawResult loadCallback',tab)
            if(!tab){
                return
            }
            console.log('useDrawResult1',tab)
            // 当tab变化时要关闭这个循环
            // const interval = setInterval(()=>{
            //     // 检查tab是否有变化
            // },1000)
            // 偿试20次获取下次开奖
            for(let i =0;i<10;i++){
                console.log('useDrawResult1 tabRef.current.path !== tab.path',tabRef.current.path,tab.path)
                if(tabRef.current.path !== tab.path){
                    
                    return
                }
                // 判断当前期数
                const {path} = tab
                const issueNumber = getCurrentIssueNumber(parseInt(path.split('_')[1]))
                const newPath = path.replace('_latest','_'+issueNumber)
                setLoadingStatus(true)
                try{
                    const {data} = await axios(base+newPath+'?r='+new Date().getTime(),{
                        headers:{ 
                            'Referrer':''
                        }
                    })
                    console.log('data',data)
                    setDrawResult(data)
                    if(data){
                        return
                    }
                    
                }catch(e){
                    console.error('e',e)
                }finally{
                    await sleep(2000)
                }
            }
        }catch(e){
            console.error('e',e)
        }finally{
            setLoadingStatus(false)
        }
    },[tab])
    useEffect(()=>{
        loadCallback()
    },[tab,loadCallback])
    return {drawResult,loadingStatus,refreshDrawResult:loadCallback}
}

export function getPreviousIssueNumbers(issueNumber:string,count:number=20){
    const issueNumbers:string[] = []
    const date = issueNumber.substring(0,8)
    const type = issueNumber.substring(8,10)
    const sequence = issueNumber.substring(10,14)
    // console.log('getPreviousIssueNumbers',date,type,sequence,issueNumber) 
    _.times(count,n=>{
        // 
        let _issueNumber = ''
        let _sequence = parseInt(sequence)-n-1
        if(_sequence <= 0){
            const newDate = moment(date).subtract(1,'days').format('YYYYMMDD')
            const _type = parseInt(type)%4
            let lastSequence 
            if(parseInt(type)==30){
                lastSequence = 2880;
            }else{
                switch(_type){
                    case 1:
                        lastSequence = 1440;
                        break;
                    case 2:
                        lastSequence = 480;
                        break;
                    case 3:
                        lastSequence = 288;
                        break;
                    case 0:
                        lastSequence = 144;
                        break;
                }
            }
            _issueNumber = newDate + type + (lastSequence + _sequence +'').padStart(4,'0')
        }else{
            _issueNumber = date + type + (_sequence+'').padStart(4,'0')
        }
        // 第二页时才会判断这个数字
        issueNumbers.push(_issueNumber+'')
    })
    return issueNumbers
}


export type DrawResultType = {
    issueNumber:string,
    key:string,
    lottery:string,
    content:any,
    plan:{
        content:{
            bs:'b'|'s'
            oe:'o'|'e'
            '5':number[],
            '7':number[],
            '8':number[]
        }
    }
};

export const hit = (result:DrawResultType)=>{
    const {lottery} = result 
    if(!result.plan){
        return false
    }
    console.log('hit',lottery,result)
    switch(lottery){
        case 'WinGo':
                if(result.plan.content.bs === 'b' && result.content.number>4){
                    return true
                }
                if(result.plan.content.bs === 's' && result.content.number<=4){
                    return true
                }
                if(result.plan.content.oe === 'o' && result.content.number%2 === 1){
                    return true
                }
                if(result.plan.content.oe === 'e' && result.content.number%2 === 0){
                    return true
                }
                // @ts-ignore
                if(result.plan.content.numbers?.filter(num=>num===parseInt(result.content.number)).length===1){
                    return true
                }
                return false  
        case 'K3': 
            if(result.plan.content.bs === 'b' && result.content.sumCount>10){
                return true
            }
            if(result.plan.content.bs === 's' && result.content.sumCount<=10){
                return true
            }
            if(result.plan.content.oe === 'o' && result.content.sumCount%2 === 1){
                return true
            }
            if(result.plan.content.oe === 'e' && result.content.sumCount%2 === 0){
                return true
            }
            return false  
        case '5D': 
            if(result.plan.content.bs === 'b' && result.content.sumCount>22){
                return true
            }
            if(result.plan.content.bs === 's' && result.content.sumCount<=22){
                return true
            }
            if(result.plan.content.oe === 'o' && result.content.sumCount%2 === 1){
                return true
            }
            if(result.plan.content.oe === 'e' && result.content.sumCount%2 === 0){
                return true
            }
            return false  
        case 'TrxWinGo': 
            if(result.plan.content.bs === 'b' && result.content.number>4){
                return true
            }
            if(result.plan.content.bs === 's' && result.content.number<=4){
                return true
            }
            if(result.plan.content.oe === 'o' && result.content.number%2 === 1){
                return true
            }
            if(result.plan.content.oe === 'e' && result.content.number%2 === 0){
                return true
            }
            // @ts-ignore
            if(result.plan.content.numbers?.filter(num=>num===parseInt(result.content.number)).length===1){
                return true
            }
            return false 
    }
}


export const useCurrentGame = ()=>{
    const [game,setGame] = useState<string>()
    useEffect(() => {
        const handleHashChange = () => {
          const _game = new URL(window.location.href).hash.replace('#/','').split('_')[0]
          setGame(_game)
          console.log('game',_game)
          // Perform actions based on the changed hash
        };
        handleHashChange()
        window.addEventListener('hashchange', handleHashChange);
        return () => {
          window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);
    return game
}
export const calculateWinRate = (drawResults:DrawResultType[])=>{
    if(drawResults.length === 0){
        return '0%'
    } 
    let hits:any[] = drawResults.filter(r=>r.content).map(r=>hit(r))
    return ((hits.filter(h=>h).length / hits.length)*100).toFixed(0)+'%'
}

export const calculateWinTrend = (drawResults:DrawResultType[])=>{
    if(drawResults.length === 0){
        return []
    } 
    let hits:any[] = drawResults.filter(r=>r.content).map(r=>hit(r))
    return hits
} 


export type PlannerProp = {hitsCount:number,pid:string,plannerName:string}
export const useTopPlanner = ()=>{
    const [result,setResult] = useState<PlannerProp[]>()
    const [loading,setLoading] = useState<boolean>(false)
    const refresh = useCallback(async ():Promise<any>=>{
        try{
            const {data} = await axios(base+ `WinGo_30_${getCurrentIssueNumber(30)}_7_plans`+'?r='+new Date().getTime())
            const plannerHitsCount = data.map((item:any)=>{
                const {draws,plans} = item.trend
                let hitsCount = 0
                plans.forEach((plan:any,index:number)=>{
                    const draw = draws[index]
                    // 预测数字
                    const hit = plan.content.numbers.indexOf(parseInt(draw.content.number))>=0
                    console.log('plan.content.numbers',plan.content.numbers,draw.content.number,'hit',hit,plan.content.numbers.indexOf(parseInt(draw.content.number)))
                    // 开奖数字
                    if(hit){
                        hitsCount++
                    }
                })
                return {hitsCount,pid:item.pid,plannerName:item.plannerName}
            }).sort((a:PlannerProp,b:PlannerProp)=>b.hitsCount-a.hitsCount)
            console.log('plannerHitsCount',plannerHitsCount)
            setResult(plannerHitsCount)
            return data
        }catch(e){
            console.error('e',e)
        }finally{
            setLoading(false)
        }
    },[])
    return {data:result,loading,refresh} 
}
export const useLatestDraw = ()=>{
    const [result,setResult] = useState()
    const [loading,setLoading] = useState<boolean>(false)
    const refresh = useCallback(async (issueNumber:string):Promise<DrawResultType>=>{
        try{
            // /MotoRace/MotoRace_1M/GetHistoryIssuePage.json
            // /WinGo/WinGo_1M/GetHistoryIssuePage.json
            // /D5/D5_1M/GetHistoryIssuePage.json
            // /K3/K3_1M/GetHistoryIssuePage.json
            const {data} = await axios('https://draw.ar-lottery01.com/'+ issueNumber+'?r='+new Date().getTime())
            setResult(data)
            return data
        }catch(e){
            console.error('e',e)
        }finally{
            setLoading(false)
        }
    },[])
    return {data:result,loading,refresh}
}
export const useHistoryDrawResult = (tab:TabProps)=>{
    // console.log('useHistoryDrawResult',new Date().getTime())
    // const [drawResult,setDrawResult] = useState();
    const[historyDrawResult,setHistoryDrawResult] = useState<{issueNumber:string,lottery:string}[]>([])
    const [loadingStatus,setLoadingStatus] = useState(false);
    const [hitRate,setHitRate] = useState('')
    const [hitTrend,setHitTrend] = useState<boolean[]>()
    const loadCallback = useCallback(async (initLoad:boolean=false)=>{
        try{
            
            // if(!initLoad){
            //     if(loadingStatus){
            //         return 
            //     }
            // }
            // if(loadingStatus){
            //     return 
            // }
            console.log('loadCallback',new Date(),'initLoad',initLoad,tab,loadingStatus,historyDrawResult.length,historyDrawResult.length >0 && historyDrawResult[historyDrawResult.length-1]?.issueNumber)
            const {path} = tab
            // console.log('path',path,historyDrawResult.length)
            let issueNumber:string,loadFirstPage:boolean;
            
            if(initLoad){
                issueNumber = getCurrentIssueNumber(parseInt(path.split('_')[1]))
                loadFirstPage = true
            }else {
                if(historyDrawResult.length>0){
                    issueNumber = _.takeRight(historyDrawResult,1)[0].issueNumber
                    loadFirstPage = false;
                }else{
                    issueNumber =  getCurrentIssueNumber(parseInt(path.split('_')[1]))
                    loadFirstPage = true;
                }
            }
            setLoadingStatus(true)
            const issueNumbers:string[] = getPreviousIssueNumbers(issueNumber,loadFirstPage?9:10)
            if(loadFirstPage){
                // 往前插入本期号
                issueNumbers.unshift(issueNumber)
            } 
            // if(loadFirstPage){
            //     const nextIssueNumber = getNextIssueNumber(parseInt(path.split('_')[1]))
            //     issueNumbers.unshift(nextIssueNumber)
            // }
            // const newPageData = await Promise.all(issueNumbers.map(async (issueNumber,index)=>{
            //     const newPath = path.replace('_latest','_'+issueNumber)
            //     console.log('newPath',newPath) 
               
            //     const {data} = await axios(base+newPath+'?r='+new Date().getTime(),{
            //         headers:{ 
            //             'Referrer':''
            //         }
            //     }) 
            //    return data
            // }))
            let newPageData
            for(let i =0;i<10;i++){
                try{
                   const {data} =  await axios(base+ path.replace('_latest','_'+issueNumbers[0])+'_past100_draws?r='+new Date().getTime())
                   newPageData = data
                   break;
                }catch(e){
                    console.error('e',e)
                    await sleep(1000)
                }
            }
            console.log('loadCallback',newPageData.length,historyDrawResult.length,loadFirstPage)
            if(loadFirstPage){
                // setHitRate(calculateWinRate(_.take(newPageData,10)))
                // setHitTrend(calculateWinTrend(_.take(newPageData,10)))
                // 计算命中率
                // 不同彩种的计算代码有点不同
                const issueNumber = getNextIssueNumber(parseInt(path.split('_')[1]))
                // const {data} =await axios(base+path.replace('_latest','_'+issueNumber)+'_plan?r='+new Date().getTime(),{
                //     headers:{ 
                //         'Referrer':''
                //     }
                // })
                setHistoryDrawResult([{issueNumber,
                    // plan:data
                },...newPageData])
            }else{
                setHistoryDrawResult([...historyDrawResult,...newPageData])
            }
            console.log('loadCallback',historyDrawResult.length)
        }catch(e){
            console.error('e',e)
        }finally{
            setLoadingStatus(false)
        }
    },[tab,historyDrawResult,loadingStatus])
    useEffect(()=>{
        // setHistoryDrawResult([])
        console.log('loadCallback effect123',new Date().getTime(),tab)
        loadCallback(true)
    },[tab])
    return {historyDrawResult,hitTrend,loadingStatus,loadMore:loadCallback,setHistoryDrawResult,hitRate}
}
 
export default useDrawResult; 